import { render, staticRenderFns } from "./Reward_Add.vue?vue&type=template&id=245f7e1c&"
import script from "./Reward_Add.vue?vue&type=script&lang=js&"
export * from "./Reward_Add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports